import { useEffect } from 'react';
export const useClearText = ({ onSearch, optionsAreOpen, setValue, mode, selectedValues, optionsCache, onSelect, }) => {
    useEffect(() => {
        if (!optionsAreOpen && mode) {
            ({
                multiple: () => {
                    setValue('');
                    onSearch('');
                },
                single: () => {
                    if (selectedValues?.length) {
                        const value = optionsCache.current.get(selectedValues[0])?.label;
                        onSearch('');
                        if (value)
                            setValue(value);
                        else
                            console.error('AutoComplete: Option not found');
                    }
                    else {
                        setValue('');
                        onSearch('');
                    }
                },
            })[mode]();
        }
    }, [optionsAreOpen, setValue, onSearch, mode, optionsCache, onSelect]);
};
